// Single source of truth for membership + member pricing.
// Swap the numbers here and the entire site updates.

export const MEMBERSHIP = {
  monthly: 49,
  annual: 499,           // marketed price
  monthlyEquivalentAnnual: 41.58, // 499/12, used for "$/mo when billed annually"
  annualSavings: 89,     // (49*12) - 499
  annualSavingsPct: 15,  // rounded
};

export type ProtocolPrice = {
  name: string;
  category: string;
  intakeKey:
    | "glp1"
    | "peptides"
    | "longevity"
    | "hormones"
    | "wholeHealth"
    | "microdosing"
    | "default";
  nonMember: number;       // $/month (or quarter for labs)
  member: number | "included";
  unit: "mo" | "qtr";
};

export const PROTOCOL_PRICES: ProtocolPrice[] = [
  {
    name: "GLP-1 (semaglutide)",
    category: "Weight",
    intakeKey: "glp1",
    nonMember: 249,
    member: 149,
    unit: "mo",
  },
  {
    name: "GLP-1 (tirzepatide)",
    category: "Weight",
    intakeKey: "glp1",
    nonMember: 399,
    member: 279,
    unit: "mo",
  },
  {
    name: "Peptides (BPC-157, Ipamorelin)",
    category: "Recovery",
    intakeKey: "peptides",
    nonMember: 199,
    member: 129,
    unit: "mo",
  },
  {
    name: "Hormone optimization (TRT / HRT)",
    category: "Hormones",
    intakeKey: "hormones",
    nonMember: 229,
    member: 149,
    unit: "mo",
  },
  {
    name: "Longevity (NAD+, Rapamycin)",
    category: "Healthspan",
    intakeKey: "longevity",
    nonMember: 179,
    member: 109,
    unit: "mo",
  },
  {
    name: "Microdosing & cognitive",
    category: "Cognitive",
    intakeKey: "microdosing",
    nonMember: 169,
    member: 99,
    unit: "mo",
  },
  {
    name: "Whole-health labs (full panel)",
    category: "Foundation",
    intakeKey: "wholeHealth",
    nonMember: 199,
    member: "included",
    unit: "qtr",
  },
];

// Lookup by category for category cards
export const PRICE_BY_INTAKE: Record<string, { nonMember: number; member: number }> = {
  glp1: { nonMember: 249, member: 149 },
  peptides: { nonMember: 199, member: 129 },
  longevity: { nonMember: 179, member: 109 },
  hormones: { nonMember: 229, member: 149 },
  wholeHealth: { nonMember: 79, member: 0 }, // labs included in membership
  microdosing: { nonMember: 169, member: 99 },
};

// Example "stack" used in the Membership savings panel
export const EXAMPLE_STACK = {
  items: [
    { label: "GLP-1 (semaglutide)", nonMember: 249, member: 149 },
    { label: "Hormone optimization", nonMember: 229, member: 149 },
    { label: "Quarterly labs", nonMember: 66, member: 0 }, // 199/qtr ≈ 66/mo
  ],
  // totals computed from items in component
};
